'use client'

import { Image } from '@vinted/web-ui'

import { FeedbackUserModel } from '@marketplace-web/profile/profile-feedback-data'
import { EMPTY_USER_IMAGE_NAME, useAsset } from '@marketplace-web/shared/assets'

type Size = Pick<React.ComponentProps<typeof Image>, 'size'>

type Props = Size & {
  user?: FeedbackUserModel
  isSystem: boolean
}

const FeedbackThumbnail = ({ user, size, isSystem }: Props) => {
  const asset = useAsset('assets/no-photo')
  const defaultPhoto = asset(EMPTY_USER_IMAGE_NAME)

  if (isSystem) {
    return (
      <Image
        role="img"
        src={asset('user-clothing/system-photo/default.png')}
        styling={Image.Styling.Circle}
        size={size}
      />
    )
  }

  if (user) {
    return (
      <a href={user.profileUrl}>
        <Image
          role="img"
          styling={Image.Styling.Circle}
          size={size}
          src={user.photoUrl || defaultPhoto}
        />
      </a>
    )
  }

  return <Image role="img" src={defaultPhoto} styling={Image.Styling.Circle} size={size} />
}

export default FeedbackThumbnail
